import * as React from "react";
import { Avatar, AvatarFallback, AvatarImage } from "frontend-components/components/ui/avatar";
import { getUserAvatarFallback } from "frontend-components/lib/user-avatar";
import { cn } from "frontend-components/lib/utils";

interface UserAvatarProps
    extends Omit<React.ComponentProps<typeof Avatar>, "children" | "variant"> {
    userId: number;
    firstName: string;
    lastName: string;
    src?: string;
}

function UserAvatar({ userId, firstName, lastName, src, className, ...props }: UserAvatarProps) {
    const fallback = getUserAvatarFallback(userId, firstName, lastName);

    return (
        <Avatar data-slot="user-avatar" className={cn("@container", className)} {...props}>
            {src && <AvatarImage src={src} alt="" />}
            <AvatarFallback className={cn("font-normal", fallback.className)}>
                <span className="text-avatar-initials">{fallback.initials}</span>
            </AvatarFallback>
        </Avatar>
    );
}

export { UserAvatar };
export type { UserAvatarProps };
